import { DatePipe } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, IFilter, PageSettingsModel, RowSelectEventArgs, SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetHTTPService } from './operational-dashboard.DataService';
import { ClaimdashboardBO, exceededhourBO, getExcludedOigListeBase, GetListBO, pgmTypeBO } from './operational-dashboard.modal';
import * as pbi from "powerbi-client";
import { OperationalDashboardService } from './operational-dashboard.service';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { operationalclaimservice } from './operational-dashboard.serviceclaim';
import { ConfigurationService } from 'src/app/configuration.service';
import { OigExceedDataServiceService } from './oig-exceed-data-service.service';
import { GetEINService } from './operational-dashboard.EINDataService';
import { GetPgmTypeService } from './operational-dashboard.pgmtypedataservice';
import { CommonHttpService } from 'src/app/common.service';
@Component({
  selector: 'app-operational-dashboard',
  templateUrl: './operational-dashboard.component.html',
  styleUrls: ['./operational-dashboard.component.scss']
})
export class OperationalDashboardComponent implements OnInit {
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  private onDestroy$: Subject<void> = new Subject<void>();
  claimdata: ClaimdashboardBO = new ClaimdashboardBO();
  view: string = 'Total';
  single: any = [];
  multi: any = [];
  auth: any = [];
  Active87PClaimcount: any = []
  Active87IClaimcount: any = []
  Archeive87PClaimcount: any = []
  Archeive87IClaimcount: any = []
  Active87PClaimAmount: any = []
  Active87IClaimAmount: any = []
  Archeive87PClaimAmount: any = []
  Archeive87IClaimAmount: any = []
  Claim837IDatas: any = []
  currentDate: any;
  AuthDueList: any;
  AuthDataList: any = [];
  gradient: boolean = false;
  Token: string = "";
  clientAuthCount: string;
  colorScheme = {
    domain: ['#689F38', '#0D47A1', '#F47B00', '#0096A6', '#378D3B', '#606060']
  };

  colorScheme1 = {
    domain: ['#0096A6', '#2a0468']
  };

  pgmTypeColorScheme = {
    domain: ['#0096A6', '#2a0468', '#0D47A1']
  };
  //#region OIG
  getmatchedleie: GetListBO = new GetListBO();
  @ViewChild('gridOig') public gridOig: GridComponent;
  matchedleie: Observable<any>;
  //#endregion
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: true,
    editableDateField: true
  };
  Expired30DEndDate: any;
  Expired60DStartDate: any;
  Expired60DEndDate: any;
  Expired90DEndDate: any;
  Expired90DStartDate: any;
  AuthStartDate: any;
  AuthEndDate: any;
  ////////////////////////////////////////////////// obserable variable /////////////////////////////////////////////////////////
  public data: Observable<DataStateChangeEventArgs>;
  public dataExcluded: Observable<DataStateChangeEventArgs>;
  public dataAuth: Observable<DataStateChangeEventArgs>;
  public EINData: Observable<DataStateChangeEventArgs>;
  public PGMTypeData: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;


  id: string = '00000000-0000-0000-0000-000000000000';


  //===============================Ejs Grid Variable Intialization========================================================//
  @ViewChild('grid') public grid: GridComponent;

  @ViewChild('gridAuthList') public gridAuthList: GridComponent;
  public pageSizes: number[] = [10, 15, 20, 50, 250];
  public submissiondrop: string[];
  public height = '220px';
  public toolbar: ToolbarItems[];
  public searchSettings: SearchSettingsModel;
  public filterOptions: object;
  public filterSettings: object;
  initialPage: PageSettingsModel;
  ComingDueinitialPage: object;
  ComingDuePage: object
  initialPage1: PageSettingsModel;
  filter: IFilter;
  ComingDueType: string = "currentpage"
  datalngth: number;
  EXPBOOL1: boolean = true;
  EXPBOOL2: boolean = true;
  EXPBOOL3: boolean = true;
  EXPBOOL4: boolean = true;
  ComingDueBool: boolean = false;
  reportcontain: boolean = false;
  file;
  filename;
  selected: boolean = false;
  configuration: any;
  showdashboardpage: boolean = false;
  ReportstatusList: any = []
  EmployeeDropdown: any = [];
  ExcludedEmployeesList: any = [];
  month: string = (new Date().getMonth() + 1).toString();
  monthList: any = [];
  Oiglist: any = [];
  currentYear: number;
  year: number = new Date().getUTCFullYear();
  curmonth: string = "";
  status: string;
  previousDate: any
  AuthPreviousDate: any;
  Employee: string;
  enableExhours: boolean = true;
  locationId: string = '00000000-0000-0000-0000-000000000000';
  startDate: any;
  endDate: any;
  enableBt: boolean = true;
  ///////////////////////////////////////////FormatOptions/////////////////////////////////////
  public formatOptions: object;
  public formatPhoneNumber: object;
  type: string;
  report = new exceededhourBO();
  excludedReport = new getExcludedOigListeBase();
  empdata: any = []
  Excludedbool: boolean = true;
  // filters: gettimesheetBO = new gettimesheetBO()
  //getAuthList: GetExpiringAuthListBO = new GetExpiringAuthListBO();
  agencyid_check = false
  einReport = new exceededhourBO();
  eindata: any = []
  einBool: boolean = true;
  initialPageEIN: PageSettingsModel;
  public filterSettingsEIN: object;
  @ViewChild('eingrid') public eingrid: GridComponent;
  @ViewChild('pgmtypegrid') public pgmtypegrid: GridComponent;
  einLength: number = 0;
  EditData: boolean = false;
  pgmTypeBool: boolean = true;
  pgmTypeChartList: any[] = [];
  pgmTypeReport = new pgmTypeBO();
  pgmtypedata: any = []
  TypeofWaiver: any[] = [];
  pgmTypeLength: number = 0;
  initialPagePgmType: PageSettingsModel;
  public filterSettingsPgmType: object;
  expandorCollapseall: boolean = false;

  constructor(private router: Router, public OperationalDService: OperationalDashboardService, public operationalclaimservice: operationalclaimservice,
    public global: GlobalComponent, @Inject(GetHTTPService) public getReport: GetHTTPService, public datePipe: DatePipe, @Inject(OigExceedDataServiceService) public getExcludedReport: OigExceedDataServiceService,
    public toasterservice: ToastrService, public configurationservice: ConfigurationService, @Inject(GetEINService) public getEINReport: GetEINService, @Inject(GetPgmTypeService) public getPgmTypeReport: GetPgmTypeService, public commonService: CommonHttpService) {
    this.global.checkforlogout();
    this.data = getReport;
    this.dataExcluded = getExcludedReport;
    this.configuration = this.configurationservice.getConfiguration();
    this.EINData = getEINReport;
    this.PGMTypeData = getPgmTypeReport;
  }

  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    let today = new Date();
    this.currentDate = this.datePipe.transform(today, 'yyyy-MM-dd')
    console.log(this.global.globalAgencyId, "HJHJ");
    this.initialPage = this.initialPageEIN = this.initialPagePgmType = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.initialPage1 = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    this.filterSettings = this.filterSettingsEIN = this.filterSettingsPgmType = {
      type: "Menu",
    };
    this.filterOptions = {
      type: "Menu"
    }
    // this.getExpiringAuthorizationCount();
    // this.getUMPI();
    // this.getExcludedEmployee()
    //this.get837PClaimDashboard();
    // this.getEIN();
    this.getTypeofWaiver();
    // this.getProgramType();
  }


  expand1() {
    if (this.EXPBOOL1 == false) {
      this.EXPBOOL1 = true;
    } else if (this.EXPBOOL1 == true) {
      this.EXPBOOL1 = false;
      this.getUMPI();
    }
  }

  //-------------------------------------------------------------------------------------------------------------------------------------//

  public dataChangeDashBoard(M): void {
    let val = M.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((M.sorted || []).length) {
        this.report.orderColumn = M.sorted[0].name;
        this.report.orderType =
          M.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && M.action.action != "clearFilter") {
      this.report.value = M.action.currentFilterObject.value;
      this.report.field = M.action.currentFilterObject.field;
      this.report.matchCase = M.action.currentFilterObject.matchCase;
      this.report.operator = M.action.currentFilterObject.operator;
      if (this.report.type == "number") {
        this.report.value =
          M.action.currentFilterObject.value.toString();
        this.report.field = M.action.currentFilterObject.field;
      }
    }
    else {
      if (val == "filtering" && M.action.action == "clearFilter") {
        this.report.field = "name";
        this.report.matchCase = false;
        this.report.operator = "contains";
        this.report.value = "";
        this.report.type = "string";
      }
    }
    this.getUMPI();

  }
  showDashBoardColumn() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  getUMPI() {
    if
      (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.status = "20";
    this.report.agencyId = (this.global.globalAgencyId).toString();
    this.report.locationId = this.locationId.toString();
    this.getReport.execute(this.report);
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.datalngth = data.count;
      this.empdata = data.result;
      var activeumpi = (data.result != null && data.result?.length != 0) ? data.result[0]?.activeUMPI : 0;
      var percentage = (data.count / activeumpi) * 100


      this.multi = [
        {
          name: 'Pending UMPI',
          value: Math.floor(Number(data.count))
        },
        {
          name: 'Active UMPI',
          value: Math.floor(Number(activeumpi))
        }
      ];
      //  this.grid.showColumns(['Month', 'Exceeded Hrs', 'Total Hrs']);
    })
  }

  getExcludedEmployee() {
    if
      (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }

    this.getExcludedReport.execute(this.excludedReport);

    this.dataExcluded.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ExcludedEmployeesList = data.count;
      console.log(this.ExcludedEmployeesList, 'length')

    })
  }
  public onSelect1(event) {
    if (event.name == "Pending UMPI") {
      this.global.isUMPI = false
      this.router.navigateByUrl("/Employee");
    }
    else if (event.name == "Active UMPI") {
      this.global.isUMPI = true
      this.router.navigateByUrl("/Employee");
    }
  }

  gotoempDetails(args: RowSelectEventArgs) {

    this.router.navigateByUrl("/Employee");
  }

  //===================================OnActionComplete==================================================//
  public onActionComplete(args) {
    this.report.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.report.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.report.type = args.columnType
    }
  }

  expand2() {
    if (this.EXPBOOL2 == false) {
      this.EXPBOOL2 = true;
    } else if (this.EXPBOOL2 == true) {
      this.EXPBOOL2 = false;
      this.getExpiringAuthorizationCount();
    }
  }

  onSelect(event) {
    let isValue: string = event.label;
    if (isValue == "Expired") {
      this.clientAuthCount = '0'
    }
    else if (isValue == "Expiring within 30 days") {
      this.clientAuthCount = '30'
    }
    else if (isValue == "Expiring within 60 days") {
      this.clientAuthCount = '60'
    }
    else if (isValue == "Expiring within 90 days") {
      this.clientAuthCount = '90'
    }

    this.showReport()
  }

  getExpiringAuthorizationCount() {
    if (this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == '') {
      this.global.globalLocationId = "00000000-0000-0000-0000-000000000000"
    }
    let params = new URLSearchParams();
    params.append('locationId', this.global.globalLocationId)
    params.append('currentDate', this.currentDate)

    this.OperationalDService.GetExpiringAuthList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      if (data != null) {
        this.auth = [
          {
            name: 'Expired',
            value: Math.floor(Number(data.expiredAuthCount))
          },
          {
            name: 'Expiring within 30 days',
            value: Math.floor(Number(data.expiredAuthIn1_30DaysCount))
          },
          {
            name: 'Expiring within 60 days',
            value: Math.floor(Number(data.expiredAuthIn31_60DaysCount))
          },
          {
            name: 'Expiring within 90 days',
            value: Math.floor(Number(data.expiredAuthIn61_90DaysCount))
          }
        ];
      }

    })
  }

  // ...........................................................................................................................
  getActive837PClaimDashboard() {
    let data = this.Claim837IDatas;
    if (data != null) {
      this.Active87PClaimcount = [
        {
          name: 'Progess',
          value: Math.floor(Number(data.activeSubmitted))
        },
        {
          name: 'Fully Paid',
          value: Math.floor(Number(data.activeFullyPaid))
        },
        {
          name: 'Partially Paid',
          value: Math.floor(Number(data.activePartiallyPaid))
        },
        {
          name: 'Denied',
          value: Math.floor(Number(data.activeDenied
          ))
        },


      ];
      this.Active87PClaimAmount = [
        {
          name: 'Progess',
          value: Math.floor(Number(data.activeSubmittedAmount))
        },
        {
          name: 'Fully Paid',
          value: (Math.floor(Number(data.activeFullyPaidAmount)))
        },
        {
          name: 'Partially Paid',
          value: Math.floor(Number(data.activePartiallyPaidAmount))
        },
        {
          name: 'Denied',
          value: Math.floor(Number(data.activeDeniedAmount))
        },


      ];
    }
  }

  // .......................................................getActive837IClaimDashboard........................................................................

  // getActive837IClaimDashboard() {
  //   if(this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == ''){
  //     this.global.globalLocationId="00000000-0000-0000-0000-000000000000"
  //   }
  //   let  params = new URLSearchParams();
  //     params.append('locationId',this.global.globalLocationId)
  //   this.OperationalDService.getclaim(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

  //     console.log(data,"cccccccccccccc");
  //     if (data != null) {
  //       this.Active87IClaimcount = [
  //         {
  //           name: 'Fully Paid',
  //           value: Math.floor(Number(data.activeFullyPaid))
  //         },
  //         {
  //           name: 'Partially Paid',
  //           value: Math.floor(Number(data.activePartiallyPaid))
  //         },
  //         {
  //           name: 'Denied',
  //           value: Math.floor(Number(data.activeSubmitted))
  //         },
  //         {
  //           name: 'Progess',
  //           value: Math.floor(Number(data.activeSubmitted))
  //         },

  //       ];
  //       this.Active87IClaimAmount = [
  //         {
  //           name: 'Fully Paid',
  //           value: (Math.floor(Number(data.activeFullyPaidAmount
  //             )))
  //         },
  //         {
  //           name: 'Partially Paid',
  //           value: Math.floor(Number(data.activeFullyPaidAmount))
  //         },
  //         {
  //           name: 'Denied',
  //           value: Math.floor(Number(data.activeDeniedAmount
  //             ))
  //         },
  //         {
  //           name: 'Progess',
  //           value: Math.floor(Number(data.activeSubmittedAmount))
  //         },

  //       ];
  //     }

  //   },
  //     (err: HttpErrorResponse) => {
  //       if (err) {
  //         //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
  //       }
  //     })
  // }


  // ...........................................getArchive837PClaimDashboard...........................................
  getArchive837PClaimDashboard() {
    let data = this.Claim837IDatas;
    if (data != null) {
      this.Archeive87PClaimcount = [
        {
          name: 'Progess',
          value: Math.floor(Number(data.archiveSubmitted))
        },
        {
          name: 'Fully Paid',
          value: Math.floor(Number(data.archiveFullyPaid))
        },
        {
          name: 'Partially Paid',
          value: Math.floor(Number(data.archivePartiallyPaid))
        },
        {
          name: 'Denied',
          value: Math.floor(Number(data.archiveDenied))
        },


      ];
      this.Archeive87PClaimAmount = [
        {
          name: 'Progess',
          value: Math.floor(Number(data.archiveSubmittedAmount))
        },
        {
          name: 'Fully Paid',
          value: (Math.floor(Number(data.archiveFullyPaidAmount)))
        },
        {
          name: 'Partially Paid',
          value: Math.floor(Number(data.archivePartiallyPaidAmount))
        },
        {
          name: 'Denied',
          value: Math.floor(Number(data.archiveDeniedAmount))
        },


      ];
    }
  }


  // ...........................................getArchive837IClaimDashboard...........................................
  //  getArchive837IClaimDashboard() {
  //   if(this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == ''){
  //     this.global.globalLocationId="00000000-0000-0000-0000-000000000000"
  //   }
  //   let  params = new URLSearchParams();
  //   params.append('locationId',this.global.globalLocationId)
  //   this.OperationalDService.getclaim(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

  //     console.log(data,"cccccccccccccc");
  //     if (data != null) {
  //       this.Archeive87IClaimcount = [
  //         {
  //           name: 'Fully Paid',
  //           value: Math.floor(Number(data.archiveFullyPaid
  //             ))
  //         },
  //         {
  //           name: 'Partially Paid',
  //           value: Math.floor(Number(data.archivePartiallyPaid))
  //         },
  //         {
  //           name: 'Denied',
  //           value: Math.floor(Number(data.archiveDenied))
  //         },
  //         {
  //           name: 'Progess',
  //           value: Math.floor(Number(data.archiveSubmitted))
  //         },

  //       ];
  //       this.Archeive87IClaimAmount = [
  //         {
  //           name: 'Fully Paid',
  //           value: (Math.floor(Number(data.archiveFullyPaidAmount
  //             )))
  //         },
  //         {
  //           name: 'Partially Paid',
  //           value: Math.floor(Number(data.archivePartiallyPaidAmount
  //             ))
  //         },
  //         {
  //           name: 'Denied',
  //           value: Math.floor(Number(data.archiveDeniedAmount
  //             ))
  //         },
  //         {
  //           name: 'Progess',
  //           value: Math.floor(Number(data.progressAmount))
  //         },

  //       ];
  //     }

  //   },
  //     (err: HttpErrorResponse) => {
  //       if (err) {
  //         //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
  //       }
  //     })
  // }

  gettoken() {
    return new Promise((resolve, rejects) => {
      this.OperationalDService
        .getpowerbiToken()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.Token = data;
            resolve(data);
          },
          (error: HttpErrorResponse) => {
            resolve(error.message);
          }
        );
    });
  }


  closemodal() {
    document.getElementById('openReportModal').click();
    this.reportcontain = false;
  }



  // .............................................................................................................................
  claimselect(event, status, is837I: boolean) {
    if (event.label == "Fully Paid") {
      this.global.globalclaimfilter = "FullyPaid"
    }
    else if (event.label == 'Partially Paid') {
      this.global.globalclaimfilter = "PartaillyPaid"
    }
    else if (event.label == 'Denied') {
      this.global.globalclaimfilter = "Denied"
    }
    else {
      this.global.globalclaimfilter = "Submitted"
    }
    this.global.globalClaimType = is837I;
    this.global.globalCLaimStatus = status;

    this.global.isCheckOperationDashboardRecord = true;
    this.router.navigateByUrl("/claims");
  }

  //........................................... expand4...........................................
  expand4() {
    if (this.EXPBOOL4 == false) {
      this.EXPBOOL4 = true;
    } else if (this.EXPBOOL4 == true) {
      this.EXPBOOL4 = false;
      this.get837PClaimDashboard();

    }
  }

  // ...........................................expand3...........................................
  expand3() {
    if (this.EXPBOOL3 == false) {
      this.EXPBOOL3 = true;
    } else if (this.EXPBOOL3 == true) {
      this.EXPBOOL3 = false;
      this.get837PClaimDashboard();

    }
  }



  showReport() {
    let currentTime = this.datePipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.gettoken().then((token) => {
      document.getElementById("openReportModal").click();

      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.reportId +


        "&rp:AgencyId=" +
        this.global.globalAgencyId +
        "&rp:DateRange=" + this.clientAuthCount +
        "&rp:ExecTime=" +
        currentTime +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";

      let embedReportId = this.configuration.reportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }

  dataStateChangeOIG(s) {
    let val = s.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((s.sorted || []).length) {
        this.excludedReport.orderColumn = s.sorted[0].name;
        this.excludedReport.orderType =
          s.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && s.action.action != "clearFilter") {
      this.excludedReport.value = s.action.currentFilterObject.value;
      this.excludedReport.field = s.action.currentFilterObject.field;
      this.excludedReport.matchCase = s.action.currentFilterObject.matchCase;
      this.excludedReport.operator = s.action.currentFilterObject.operator;
      if (this.excludedReport.type == "number") {
        this.excludedReport.value =
          s.action.currentFilterObject.value.toString();
        this.excludedReport.field = s.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && s.action.action == "clearFilter") {
        this.excludedReport.field = "name";
        this.excludedReport.matchCase = false;
        this.excludedReport.operator = "contains";
        this.excludedReport.value = "";
        this.excludedReport.type = "string";
      }
    }
    this.getExcludedEmployee();

  }

  OnactionBeginOIG(s) {
    this.excludedReport.currentpageno = this.gridOig.pagerModule.pagerObj.currentPage;
    this.excludedReport.pageitem = this.gridOig.pagerModule.pagerObj.pageSize;
    if (s.name == "actionBegin" && s.requestType == "filterbeforeopen") {
      this.excludedReport.type = s.columnType
    }
  }


  expandExcludedAuth() {
    this.Excludedbool = !this.Excludedbool;
    if (this.Excludedbool == false) {
      this.getExcludedEmployee();
    }
  }
  openOig() {
    this.router.navigateByUrl('/oig')
  }

  expandEIN() {
    this.einLength = 0;
    if (this.einBool == false) {
      this.einBool = true;
    } else if (this.einBool == true) {
      this.einBool = false;
      this.getEIN();
    }
  }

  public dataChangeEIN(M): void {
    let val = M.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((M.sorted || []).length) {
        this.einReport.orderColumn = M.sorted[0].name;
        this.einReport.orderType =
          M.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && M.action.action != "clearFilter") {
      this.einReport.value = M.action.currentFilterObject.value;
      this.einReport.field = M.action.currentFilterObject.field;
      this.einReport.matchCase = M.action.currentFilterObject.matchCase;
      this.einReport.operator = M.action.currentFilterObject.operator;
      if (this.einReport.type == "number") {
        this.einReport.value =
          M.action.currentFilterObject.value.toString();
        this.einReport.field = M.action.currentFilterObject.field;
      }
    }
    else {
      if (val == "filtering" && M.action.action == "clearFilter") {
        this.einReport.field = "name";
        this.einReport.matchCase = false;
        this.einReport.operator = "contains";
        this.einReport.value = "";
        this.einReport.type = "string";
      }
    }
    this.getEIN();
  }

  public onActionCompleteEIN(args) {
    this.einReport.currentpageno = this.eingrid.pagerModule.pagerObj.currentPage;
    this.einReport.pageitem = this.eingrid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.einReport.type = args.columnType
    }
  }

  getEIN() {
    if
      (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.status = "20";
    this.einReport.agencyId = (this.global.globalAgencyId).toString();
    this.einReport.locationId = this.locationId.toString();
    this.getEINReport.execute(this.einReport);
    this.EINData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.eindata = data.result;
      this.einLength = data.count;
    })
  }

  gotoClientDetailsEIN(args: RowSelectEventArgs) {
    setTimeout(() => {
      let val = this.eingrid.selectedRowIndex;
      if (val != -1) {
        let val1 = this.eindata[val];
        this.global.clientId = val1.id;
        this.global.globalclientdata = val1;
        this.global.globalclientdata.dOB = val1?.dob;
        this.router.navigateByUrl("/Client");
      }
    }, 200);
  }

  gotoClientDetailsPT(args: RowSelectEventArgs) {
    setTimeout(() => {
      let val = this.pgmtypegrid.selectedRowIndex;
      if (val != -1) {
        let val1 = this.pgmtypedata[val];
        this.global.clientId = val1.id;
        this.global.globalclientdata = val1;
        this.global.globalclientdata.dOB = val1?.dob;
        this.router.navigateByUrl("/Client");
      }
    }, 200);
  }

  expandPgmType() {
    if (this.pgmTypeBool == false) {
      this.pgmTypeBool = true;
    } else if (this.pgmTypeBool == true) {
      this.pgmTypeBool = false;
      this.getProgramType();
    }
  }

  public onSelectPgmType(event) {
    console.log("event.......", event)
    this.pgmTypeReport.pgmTypeLid = this.TypeofWaiver.find(x => x.lovName.includes(event.name))?.id;
    console.log("wavier", this.TypeofWaiver)
    console.log("this.pgmTypeReport.pgmTypeLid...", this.pgmTypeReport.pgmTypeLid)
    if (event.value === 0) {
      console.log("No data available for the selected program type.");
      return;
    }else {
      this.getProgramType();
    }
  }

  getProgramType() {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.status = "20";
    this.pgmTypeReport.agencyId = (this.global.globalAgencyId).toString();
    this.pgmTypeReport.locationId = this.locationId.toString();
    console.log("pgmTypeReport.........", this.pgmTypeReport)
    this.getPgmTypeReport.execute(this.pgmTypeReport);
    this.PGMTypeData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.pgmtypedata = data.result;
      this.pgmTypeLength = data.count;
      this.pgmTypeChartList = [
        {
          name: 'CDCS',
          value: Math.floor(Number(data.cdcs))
        },
        {
          name: 'DD',
          value: Math.floor(Number(data.dd))
        },
        {
          name: 'CSGP',
          value: Math.floor(Number(data.csgp))
        }
      ];
    })
  }

  //..............................................getTypeofWaiver.................................................
  getTypeofWaiver() {
    let params = new URLSearchParams();
    params.append("listCode", "TYPEOFWAIVER");
    this.commonService.getStatus(params).subscribe((data: any) => {
      this.TypeofWaiver = data;
    })

  }

  public dataChangePgmType(M): void {
    let val = M.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((M.sorted || []).length) {
        this.pgmTypeReport.orderColumn = M.sorted[0].name;
        this.pgmTypeReport.orderType =
          M.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && M.action.action != "clearFilter") {
      this.pgmTypeReport.value = M.action.currentFilterObject.value;
      this.pgmTypeReport.field = M.action.currentFilterObject.field;
      this.pgmTypeReport.matchCase = M.action.currentFilterObject.matchCase;
      this.pgmTypeReport.operator = M.action.currentFilterObject.operator;
      if (this.pgmTypeReport.type == "number") {
        this.pgmTypeReport.value =
          M.action.currentFilterObject.value.toString();
        this.pgmTypeReport.field = M.action.currentFilterObject.field;
      }
    }
    else {
      if (val == "filtering" && M.action.action == "clearFilter") {
        this.pgmTypeReport.field = "name";
        this.pgmTypeReport.matchCase = false;
        this.pgmTypeReport.operator = "contains";
        this.pgmTypeReport.value = "";
        this.pgmTypeReport.type = "string";
      }
    }
    this.getProgramType();
  }

  public onActionCompletePgmType(args) {
    this.einReport.currentpageno = this.pgmtypegrid.pagerModule.pagerObj.currentPage;
    this.einReport.pageitem = this.pgmtypegrid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.einReport.type = args.columnType
    }
  }

  // ...........................................get837PClaimDashboard...........................................
  get837PClaimDashboard() {
    if (this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == '') {
      this.global.globalLocationId = "00000000-0000-0000-0000-000000000000"
    }
    let params = new URLSearchParams();
    params.append('locationId', this.global.globalLocationId)
    this.OperationalDService.getclaim(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.Claim837IDatas = data;
        this.getActive837PClaimDashboard();
        this.getArchive837PClaimDashboard();
      }

    },
      (err: HttpErrorResponse) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }

  ExpandAll() {
    this.expandorCollapseall = true;
    this.EXPBOOL1 = this.EXPBOOL2 = this.EXPBOOL3 = this.EXPBOOL4 = this.Excludedbool = this.einBool = this.pgmTypeBool = false;
    this.getExpiringAuthorizationCount();
    this.getUMPI();
    this.getExcludedEmployee()
    this.get837PClaimDashboard();
    this.getEIN();
    this.getTypeofWaiver();
    this.getProgramType();
  }

  CollapesAll() {
    this.expandorCollapseall = false;
    this.collapseCard();
  }
  collapseCard() {
    this.EXPBOOL1 = this.EXPBOOL2 = this.EXPBOOL3 = this.EXPBOOL4 = this.Excludedbool = this.einBool = this.pgmTypeBool = true;
  }

}

